import {
	type FrontendPlacementMessage,
	type AnyFrontendStage,
} from '@post-office/message-maker-browser/types';

import AiGenerativeTextSummaryIcon from '@atlaskit/icon/core/ai-generative-text-summary';

import PageIcon from '@atlaskit/icon/core/page';

import IconTile from '@atlaskit/icon/icon-tile';

import { token } from '@atlaskit/tokens';

import { noValidation } from '@post-office/message-maker-browser/message-helpers';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

import {
	PlacementFrontend,
	type CustomPlacementProps,
} from '@post-office/browser--growth-starburst/project-assets-ai-suggestions';

import { FormattedMessage } from 'react-intl';

import { type MessageTemplateContext } from '../../..';

import { SuggestionCard } from '@post-office/browser--growth-starburst/common/components/suggestion-card';

export const MessageFrontend: (
	config: CreatePlacementMessageConfig,
) => FrontendPlacementMessage<{ render: AnyFrontendStage }> =
	PlacementFrontend.createMessageFrontend({
		render: {
			validate: noValidation<MessageTemplateContext>(),
			Component: ({
				issueKey,
				additionalIssueCount,
				onSnoozeClick,
			}: CustomPlacementProps & MessageTemplateContext) => {
				return (
					<SuggestionCard
						icon={<IconTile icon={PageIcon} label="" appearance="tealBold" size="small" />}
						title={
							<FormattedMessage
								id="post-office.project-assets-ai-suggestions.weekly-summary.title"
								defaultMessage="Create a weekly summary"
								description="Title for the weekly summary suggestion card"
							/>
						}
						description={
							<FormattedMessage
								id="post-office.project-assets-ai-suggestions.weekly-summary.description"
								defaultMessage="Create a summary for completed tasks {issueKey}{additionalCount} to share with leadership."
								description="Description for the weekly summary suggestion card"
								// TODO: Placeholder, will update with smart link
								values={{
									issueKey: (
										<a href={`https://jira.atlassian.com/browse/${issueKey}`}>{issueKey}</a>
									),
									additionalCount:
										additionalIssueCount > 0 ? (
											<FormattedMessage
												id="post-office.project-assets-ai-suggestions.weekly-summary.additional-count"
												defaultMessage=" +{count}"
												description="Additional issue count label"
												values={{ count: additionalIssueCount }}
											/>
										) : (
											''
										),
								}}
							/>
						}
						ctaLabel={
							<FormattedMessage
								id="post-office.project-assets-ai-suggestions.weekly-summary.cta"
								defaultMessage="Create summary"
								description="CTA button label for the weekly summary suggestion card"
							/>
						}
						ctaIcon={<AiGenerativeTextSummaryIcon label="" color={token('color.icon.subtle')} />}
						onSnoozeClick={onSnoozeClick}
						onCtaClick={() => {
							// TODO: STARB-3241 open CWR modal
						}}
					/>
				);
			},
		},
	});
